import { SidebarItems, PageNames, IconSizeEnum } from "../types/AppTypes";
import {
  COLLABORATORS_LABEL,
  AREA_DEVELOPMENT,
  POTENTIAL_MATRIX_LABEL,
  ORGANIZATIONAL_CHART_LABEL,
  FORMATION_LABEL,
  TECH_SKILLS_LABEL,
  MANAGEMENT_LABEL,
  PERFORMANCE_COACH_LABEL,
  PERSONAL_PROFILE_LABEL,
  POTENTIAL_MATRIXV3_LABEL,
} from "./Dictionary";
import { ReactComponent as OrganizationChartIcon } from "../icons/organization.svg";
import { ReactComponent as CollaboratorIcon } from "../icons/users.svg";
import { ReactComponent as PotentialMatrixIcon } from "../icons/potential_matrix.svg";
import { ReactComponent as AreaDevelopmentIcon } from "../icons/areaDevelopment.svg";
import { ReactComponent as TrainingIcon } from "../icons/training.svg";
import { ReactComponent as TechSkillsIcon } from "../icons/tech_skills.svg";
import { ReactComponent as ManagementIcon } from "../icons/manage.svg";
import { ReactComponent as CareerManagerIcon } from "../icons/careerManager.svg";
import { ReactComponent as UserIcon } from "../icons/user.svg";
import { IconManager } from "../components/core/IconManager/IconManager";
import { roleHasPermission } from "../utils/roleAuth.utils";
import { AuthProfile } from "../types/api/auth.type";
import { isProd, isQA } from "../utils/generals.utils";
import { PermissionsEnum } from "./AppConstants";

const MENU_ITEMS: SidebarItems[] = [
  {
    icon: (
      <IconManager size={IconSizeEnum.MEDIUM}>
        <CollaboratorIcon />
      </IconManager>
    ),
    label: COLLABORATORS_LABEL,
    link: PageNames.COLLABORATORS,
    permission: PermissionsEnum.SIDEBAR_COLLABORATORS,
  },
  {
    icon: (
      <IconManager size={IconSizeEnum.MEDIUM}>
        <CareerManagerIcon />
      </IconManager>
    ),
    label: PERFORMANCE_COACH_LABEL,
    link: PageNames.CAREER_MANAGER,
    permission: PermissionsEnum.SIDEBAR_MANAGE_CAREER,
  },
  {
    icon: (
      <IconManager size={IconSizeEnum.MEDIUM}>
        <AreaDevelopmentIcon />
      </IconManager>
    ),
    label: AREA_DEVELOPMENT,
    link: PageNames.AREA_DEVELOPMENT,
    permission: PermissionsEnum.SIDEBAR_AREA_DEVELOPMENT,
  },
  ...(isProd() || isQA()
    ? []
    : [
        {
          icon: (
            <IconManager size={IconSizeEnum.MEDIUM}>
              <PotentialMatrixIcon />
            </IconManager>
          ),
          label: POTENTIAL_MATRIX_LABEL,
          link: PageNames.POTENTIAL_MATRIX,
          permission: PermissionsEnum.SIDEBAR_MATRIX,
        },
        {
          icon: (
            <IconManager size={IconSizeEnum.MEDIUM}>
              <PotentialMatrixIcon />
            </IconManager>
          ),
          label: POTENTIAL_MATRIXV3_LABEL,
          link: PageNames.POTENTIAL_MATRIXV3,
          permission: PermissionsEnum.SIDEBAR_MATRIX,
        },
        {
          icon: (
            <IconManager size={IconSizeEnum.MEDIUM}>
              <TrainingIcon />
            </IconManager>
          ),
          label: FORMATION_LABEL,
          link: PageNames.FORMATION,
          permission: PermissionsEnum.SIDEBAR_FORMATION,
        },
      ]),
  {
    icon: (
      <IconManager size={IconSizeEnum.MEDIUM}>
        <TechSkillsIcon />
      </IconManager>
    ),
    label: TECH_SKILLS_LABEL,
    link: PageNames.TECH_SKILLS,
    permission: PermissionsEnum.SIDEBAR_TECH_SKILLS,
  },
  {
    icon: (
      <IconManager size={IconSizeEnum.MEDIUM}>
        <ManagementIcon />
      </IconManager>
    ),
    label: MANAGEMENT_LABEL,
    link: PageNames.MANAGEMENT,
    permission: PermissionsEnum.SIDEBAR_MANAGEMENT,
  },
];

export const getSidebarMenuItems = (profile: AuthProfile): SidebarItems[] => [
  ...(isProd() || isQA()
    ? []
    : [
        {
          icon: (
            <IconManager size={IconSizeEnum.MEDIUM}>
              <OrganizationChartIcon />
            </IconManager>
          ),
          label: ORGANIZATIONAL_CHART_LABEL,
          link: PageNames.ORG,
          permission: PermissionsEnum.SIDEBAR_ORG,
        },
      ]),
  ...[
    ...MENU_ITEMS.filter((item) => roleHasPermission(profile, item.permission)),
  ],
];

export const SIDEBAR_BOTTOM_MENU_ITEMS = (): SidebarItems[] => [
  ...[
    {
      icon: (
        <IconManager size={IconSizeEnum.MEDIUM}>
          <UserIcon />
        </IconManager>
      ),
      label: PERSONAL_PROFILE_LABEL,
      link: PageNames.PERSONAL_PROFILE,
      permission: PermissionsEnum.SIDEBAR_PERSONAL_PROFILE,
    },
  ],
];
